import { FC, useMemo } from 'react'
import { UserProtectedRoute } from 'routes'
import { useParams } from 'react-router-dom'
import Section from 'components/Section'
import { CircularProgress } from '@mui/material'
import { useCommonRoomsReservationsList } from 'services/commonRooms/commonRooms.hooks'
import { useIntl } from 'react-intl'
import CommonRoomReservation from 'components/CommonRoomReservations/CommonRoomReservation'
import BackNavigationHeader, { BackNavigationContent } from 'components/BackNavigationHeader'

const CommonRoomReservationPage: FC = () => {
  const { formatMessage } = useIntl()
  const { id } = useParams()
  const { data: reservations = [], isFetching, isLoading } = useCommonRoomsReservationsList()

  const reservation = useMemo(
    () => reservations.find((reservation) => reservation.id === Number(id)),
    [id, reservations]
  )

  if (isFetching || isLoading) {
    return (
      <Section sx={{ flexDirection: 'column', alignItems: 'center' }}>
        <CircularProgress />
      </Section>
    )
  }

  return (
    <UserProtectedRoute>
      <BackNavigationHeader
        navigateTo='/common-room-reservations'
        desktopNavigateTo='/common-room-reservations'
        label={formatMessage(
          {
            id: 'commonRoomReservations.commonRoomReservations',
            defaultMessage: 'Rezerwacja: {reservationId}'
          },
          { reservationId: reservation?.reservationCode || '' }
        )}
      />
      <BackNavigationContent>
        {!!reservation && <CommonRoomReservation reservation={reservation} />}
      </BackNavigationContent>
    </UserProtectedRoute>
  )
}

export default CommonRoomReservationPage
